var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ContractorInvite", {
        attrs: {
          role: "CONTRACTOR",
          companyBusinessName: _vm.companyBusinessName,
          companyId: _vm.companyId,
          currentUserId: _vm.currentUserId,
          isManager: _vm.isManager,
        },
        model: {
          value: _vm.contractorDialog,
          callback: function ($$v) {
            _vm.contractorDialog = $$v
          },
          expression: "contractorDialog",
        },
      }),
      _c("UiButtonTest", {
        staticClass: "mr-12",
        attrs: {
          disabled: _vm.noCompany,
          id: "uploadContractortest",
          size: _vm.size,
          variant: "outline",
          buttonText: _vm.actionButtonContent,
        },
        on: { click: _vm.showInviteModal },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function () {
              return [_c("PlusIcon", { staticClass: "w-4 h-4" })]
            },
            proxy: true,
          },
          {
            key: "hover-icon",
            fn: function () {
              return [_c("PlusIcon", { staticClass: "w-4 h-4" })]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }